const processWord = (word, maxLen) => {
    if (word.length <= maxLen) return word
    const reduced = word[0] + word.slice(1).replace(/[AEIOU]/g, '')
    return reduced.slice(0, maxLen)
}

const slugify = (value) => {
    if (!value || typeof value !== 'string') return ''
    const words = value.trim().split(/\s+/).slice(0, 4)
    return words
        .map((word, i) => {
            const clean = word.toUpperCase().replace(/[^A-Z0-9]/g, '')
            if (!clean) return ''
            return processWord(clean, i === 0 ? 5 : 3)
        })
        .filter(Boolean)
        .join('-')
}

export default slugify
